import { gql, useMutation } from "@apollo/client";
import { Stack, usePersistedStateId } from "@comet/admin";
import { AccessTime } from "@mui/icons-material";
import { Button } from "@mui/material";
import { PageHeader } from "@src/components";
import { type GQLUpdateCamerasTimeAdminMutation, type GQLUpdateCamerasTimeAdminMutationVariables } from "@src/graphql.generated";
import { useUser } from "@vivid/react-oidc-client";
import { type FC, type PropsWithChildren } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Table from "./Table";

const updateCamerasTimeAdminMutation = gql`
    mutation UpdateCamerasTimeAdmin($input: BulkCameraInput!) {
        updateCamerasTimeAdmin(input: $input) {
            id
        }
    }
`;

const BulkButton: FC<PropsWithChildren> = () => {
    const user = useUser();
    const [updateCamerasTimeMutation, { loading }] = useMutation<GQLUpdateCamerasTimeAdminMutation, GQLUpdateCamerasTimeAdminMutationVariables>(
        updateCamerasTimeAdminMutation,
        {
            refetchQueries: ["CameraBulkCommandsAdmin"],
        },
    );

    const submit = () => {
        return updateCamerasTimeMutation({
            variables: {
                input: {
                    executedBy: `${user?.given_name} ${user?.family_name}`,
                },
            },
        });
    };

    return (
        <Button variant="contained" color="primary" startIcon={<AccessTime style={{ fontSize: "20px" }} />} onClick={submit} disabled={loading}>
            <FormattedMessage id="reviermanager.page.bulkSMS.changeCamerasClock" defaultMessage="Zeitumstellung" />
        </Button>
    );
};

export default () => {
    const intl = useIntl();
    const persistedStateId = usePersistedStateId();

    return (
        <Stack topLevelTitle={intl.formatMessage({ id: "reviermanager.page.bulkSMS", defaultMessage: "Massen-SMS" })}>
            <PageHeader title={<FormattedMessage id="reviermanager.page.bulkSMS" defaultMessage="Massen-SMS" />} button={<BulkButton />} />
            <Table persistedStateId={persistedStateId} />
        </Stack>
    );
};
